import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalContainerComponent } from '@reconcept-platform/shared/ui/standalone/modal';
import { ToastNotificationsComponent } from '@reconcept-platform/shared/ui/standalone/toast-notifications';

@Component({
  selector: 'rcp-root',
  imports: [RouterOutlet, ToastNotificationsComponent, ModalContainerComponent],
  template: `
    <router-outlet />
    <rcp-toast-notifications />
    <rcp-modal-container />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: flex;
      flex-grow: 1;
    }
  `,
})
export class AppComponent {
  constructor() {
    if (localStorage.getItem('reconcept-portfolio|experimentalDarkMode')) {
      document.body.classList.add('experimentalDarkMode');
    }
  }
}
